export function blurActiveElement(): void {
  (document?.activeElement as HTMLInputElement | null)?.blur();
}
